export default __webpack_public_path__ + "static/extravagant-sea-0288958525c6a3ae9a3c9bba3703d55d.jpg";